<section class="main-wrap inner-views">
  <div class="container-wrap">
    <div class="sidebar-container sc-empty">
      <app-sidebar-empty></app-sidebar-empty>
    </div>
    <div class="content-container login-container address-container">
      <div class="row setup-complete">
        <div class="col-md-12">
          <h1>Setup Complete!</h1>
          <p class="subtitle completed">
            We are redirecting you to the proper place.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
